export const TEST_ID = 'combobox';
